export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}report/overview`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        getMetablocks: {
            method: 'POST',
            isArray: true,
            url: `${url}/metablocks-report`
        },
        getDeviceStatistics: {
            method: 'POST',
            isArray: true,
            url: `${url}/device-statistics-report`
        },
        getLearningCatalogueSearches: {
            method: 'POST',
            isArray: true,
            url: `${url}/learning-catalogue-searches`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/ReportOverview/index.js